var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 227.68,
    cy: 908.84,
    r: 1071.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#f2203e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#b71fa8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5351d6"
  })), /*#__PURE__*/React.createElement("style", null, "\n      .cls-1{fill:url(#radial-gradient);}\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M745.32 70.76H334.68c-145.79 0-263.92 118.12-263.92 263.92v410.64c0 145.79 118.13 263.92 263.92 263.92h410.64c145.64 0 263.92-118.13 263.92-263.92V334.68c0-145.8-118.24-263.92-263.92-263.92ZM924.26 744.1c-3.19 65.37-30.41 106.57-47.74 123.91-57.77 59.29-124.06 59.29-336.59 59.29s-278.68 0-336.45-59.29c-17.33-17.34-44.7-58.54-47.74-123.91-3-65.53-4.56-177.12-3.8-204.18-.76-26.91.76-138.5 3.8-204s30.41-106.6 47.74-123.92c57.77-59.29 123.91-59.29 336.45-59.29s278.82 0 336.59 59.29c17.33 17.33 44.55 58.53 47.74 123.91s4.56 177.11 3.8 204c.76 27.09-.76 138.66-3.8 204.19ZM539.93 297.74c-133.79 0-242.19 108.4-242.19 242.18 0 133.94 108.4 242.34 242.19 242.34s242.33-108.4 242.33-242.34c0-133.78-108.4-242.18-242.33-242.18Zm0 399.38c-86.66 0-157-70.39-157-157.2 0-86.65 70.39-157 157-157s157.19 70.39 157.19 157a157.21 157.21 0 0 1-157.19 157.2Zm306-409.12a56.47 56.47 0 1 1-56.47-56.47A56.47 56.47 0 0 1 845.93 288Z",
    id: "_Camada_2",
    "data-name": "<Camada>"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.ee739f1965bc15a61d830bcfa21d3d30.svg";
export { ForwardRef as ReactComponent };